export * from './metadata.service';
export * from './metadata.interface';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/metadata/shared/index.ts